<div>
  <div class="row">
    <h5>{{ 'credits.order.label' | translate }}</h5>
  </div>
  <div class="block-credits">
    <div class="card" *ngFor="let package of orderOptions.packages">
      <div class="pack-name">
        {{ 'credits.order.package.' + package.name | translate }}
      </div>
      <div class="pack-item">
        <span class="glicon-circle-check"></span>
        {{ 'credits.order.credits' | translate }}: {{ package.totalCredits | number }}
      </div>
      <div class="pack-item">
        <span class="glicon-circle-check"></span>
        {{ 'credits.order.amount' | translate }}: {{ package.amount | currency : 'EUR' : 'symbol' }}
      </div>
      <div class="pack-item">
        <gl-button
          color-primary
          (onClick)="order(package)"
          [text]="'credits.order.pay' | translate"
          title="{{ 'credits.order.pay' | translate }}"
        >
        </gl-button>
      </div>
    </div>

    <div class="card padding">
      <div class="pack-item">
        <span class="glicon-circle-check"></span>
        {{ 'credits.order.other' | translate }}
      </div>
    </div>
  </div>
</div>
